import { render } from "./App.vue?vue&type=template&id=5b185c14"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5b185c14&lang=css"

import exportComponent from "/home/devuser/code/ginghamjelly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__